export default "__VITE_ASSET__Dz$xc295__"